import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: process.env.API + '/api'
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js